module.exports = __webpack_public_path__ + "img/more-black.3663e0e.png";